<template>
    <div class="text-center pra-popup">
        <div v-if="entry">
            <p>
                <span class="font-medium">{{ entry.property_id }}</span>
                <span v-if="!state.hidePill" class="label label-rouded m-l-5" :class="'label-' + state.theme">{{ $t(state.label) }}</span>
                <span v-if="entry.manual" class="label label-rouded pra-manual-badge m-l-5">{{ $t("amas:analysis:pra:manual_added") }}</span>
                <span v-else-if="entry.overridden" class="label label-rouded pra-manual-badge m-l-5">{{ $t("amas:analysis:pra:manual_edited") }}</span>
            </p>
            <table v-if="entry.depth !== 0" class="pra-popup-conditions">
                <tr>
                    <td>{{ $t("amas:analysis:pra:legal_access") }}</td>
                    <td>
                        <true-false-selector
                            :value="entry.legal.ok"
                            @select="$emit('override', entry.property_id, 'has_legal_access', $event)"
                        />
                    </td>
                </tr>
                <tr>
                    <td>{{ $t("amas:analysis:pra:physical_access") }}</td>
                    <td>
                        <true-false-selector
                            :value="entry.physical.ok"
                            @select="$emit('override', entry.property_id, 'has_physical_access', $event)"
                        />
                    </td>
                </tr>
                <tr>
                    <td>{{ $t("amas:analysis:pra:state_road") }}</td>
                    <td>
                        <true-false-selector
                            :value="!!entry.has_public_road"
                            @select="$emit('override', entry.property_id, 'has_public_road', $event)"
                        />
                    </td>
                </tr>
            </table>
            <span v-if="canRemove"
                v-tooltip="$t('amas:analysis:pra:remove_from_access')"
                class="btn btn-xs btn-outline btn-rounded btn-danger m-t-10"
                @click="$emit('remove_step', property_id)"
            >
                {{ $t("general:remove") }}
            </span>
        </div>
        <div v-else>
            <p>{{ $t("amas:analysis:pra:parcel_id") }}
                <template v-if="parcel">
                    '{{parcel.property_id}}'
                </template>
                <template v-else>
                    <span class="fa fa-spinner fa-spin"></span>
                </template>
            </p>

            <span v-if="parcel && canAdd"
                v-tooltip="$t('amas:analysis:pra:add_to_access')"
                class="btn btn-xs btn-outline btn-rounded btn-info m-b-10"
                @click="$emit('add_step', parcel.property_id)"
            >
                {{ $t("general:add") }}
            </span>
        </div>
    </div>
</template>

<script>
import TrueFalseSelector from "./TrueFalseSelector.vue";
import { STATES } from "../states.js";

export default {
    name: "PopupTable",
    components: { TrueFalseSelector },
    props: {
        entry: {
            type: Object,
            default: null
        },
        parcel: {
            type: Object,
            default: null
        },
        property_id: {
            type: [String, Number],
            default: null
        },
        canAdd: {
            type: Boolean,
            default: false
        },
        canRemove: {
            type: Boolean,
            default: false
        }
    },
    computed: {
        state() { return STATES[this.entry && this.entry.state] || STATES.off_route; },
    },
    emits: ["add_step", "remove_step", "override"]
}
</script>

<style>
.pra-popup { padding: 4px 6px 12px; }
.pra-popup-conditions { margin: 0 auto; }
.pra-popup-conditions td { padding: 2px 6px; text-align: left; vertical-align: middle; }
.pra-popup-conditions .arvio-pra-true-false-selector .btn { padding: 0; }
</style>
